
		<div class="tig-check" [ngClass]="{'checked': OBJ_input.checked, 'disabled': OBJ_input.disabled}">
			<ng-content></ng-content>
		</div>
	